import { Link } from 'react-router-dom';

const services = [
  {
    id: 'badkamer',
    icon: 'ri-drop-line',
    tag: 'Badkamer Renovatie',
    title: 'Badkamer Verbouwing',
    subtitle: 'Antwerpen & Omgeving',
    description:
      'Wij transformeren uw badkamer tot een moderne, functionele en stijlvolle ruimte. Van volledige sloop tot sleutelklare oplevering: tegels, sanitair, douche, bad, verlichting en ventilatie — alles wordt vakkundig uitgevoerd.',
    features: [
      'Volledige sloop & afvoer',
      'Tegelwerk & vloerleggen',
      'Sanitair installatie',
      'Inloopdouche & bad',
      'Verlichting & ventilatie',
      'Sleutelklare oplevering',
    ],
    image:
      'https://public.readdy.ai/ai/img_res/48b46b2cc4c73a79d6ac905906d0db3d.jpg',
    alt: 'Badkamer renovatie Antwerpen – NGP Renovatieproject',
    schemaName: 'Badkamer Renovatie Antwerpen',
    schemaDescription:
      'Professionele badkamer verbouwing in Antwerpen en omgeving. Volledige renovatie inclusief tegelwerk, sanitair, douche, bad en verlichting door NGP Renovatieproject.',
  },
  {
    id: 'keuken',
    icon: 'ri-restaurant-line',
    tag: 'Keuken Renovatie',
    title: 'Keuken Verbouwing',
    subtitle: 'Antwerpen & Omgeving',
    description:
      'Een nieuwe keuken geeft uw woning een compleet nieuwe uitstraling. Wij verzorgen de volledige keukenrenovatie: van demontage van de oude keuken tot installatie van nieuwe kasten, werkblad, tegels, verlichting en apparatuur.',
    features: [
      'Demontage oude keuken',
      'Nieuwe keukenkasten & werkblad',
      'Tegelwerk achterwand',
      'Elektra & loodgieterij',
      'Inbouwapparatuur',
      'Afwerking & schilderwerk',
    ],
    image:
      'https://readdy.ai/api/search-image?query=modern%20kitchen%20renovation%20antwerp%20belgium%20white%20cabinets%20marble%20countertop%20open%20plan%20minimalist%20design%20pendant%20lights%20clean%20contemporary%20interior%20high%20end%20appliances%20natural%20light%20professional%20photography%20elegant&width=800&height=600&seq=servizi-keuken-01&orientation=landscape',
    alt: 'Keuken renovatie Antwerpen – NGP Renovatieproject',
    schemaName: 'Keuken Renovatie Antwerpen',
    schemaDescription:
      'Professionele keuken verbouwing in Antwerpen en omgeving. Volledige renovatie inclusief kasten, werkblad, tegelwerk en installatie door NGP Renovatieproject.',
  },
  {
    id: 'appartement',
    icon: 'ri-building-line',
    tag: 'Appartement Renovatie',
    title: 'Volledige Appartement Renovatie',
    subtitle: 'Antwerpen & Omgeving',
    description:
      'Van een verouderd appartement naar een moderne, comfortabele woning. Wij nemen de volledige renovatie op ons: vloeren, wanden, plafonds, elektriciteit, sanitair, schilderwerk en meer — één aannemer voor het hele project.',
    features: [
      'Vloeren & parket',
      'Wanden & plafonds',
      'Elektriciteit & verlichting',
      'Sanitair & loodgieterij',
      'Schilderwerk & afwerking',
      'Projectbegeleiding',
    ],
    image:
      'https://readdy.ai/api/search-image?query=complete%20apartment%20renovation%20antwerp%20belgium%20open%20living%20room%20modern%20minimalist%20white%20walls%20wooden%20floor%20elegant%20furniture%20natural%20light%20large%20windows%20contemporary%20interior%20design%20high%20quality%20craftsmanship%20professional%20photography&width=800&height=600&seq=servizi-appartement-01&orientation=landscape',
    alt: 'Appartement renovatie Antwerpen – NGP Renovatieproject',
    schemaName: 'Appartement Renovatie Antwerpen',
    schemaDescription:
      'Volledige appartement renovatie in Antwerpen en omgeving. Één aannemer voor vloeren, wanden, elektriciteit, sanitair en afwerking door NGP Renovatieproject.',
  },
];

const ServiziList = () => {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-20">
          <span className="inline-block px-4 py-2 bg-amber-50 rounded-full text-xs font-medium text-amber-700 uppercase tracking-wider mb-4">
            Wat Wij Doen
          </span>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>
            Onze Renovatiediensten
          </h2>
          <p className="text-gray-500 max-w-xl mx-auto text-sm leading-relaxed">
            Elk project wordt met zorg en vakmanschap uitgevoerd. Wij werken in Antwerpen, Merksem en de volledige regio.
          </p>
        </div>

        <div className="space-y-24">
          {services.map((service, index) => (
            <article
              key={service.id}
              id={service.id}
              className={`flex flex-col ${index % 2 === 1 ? 'lg:flex-row-reverse' : 'lg:flex-row'} gap-12 lg:gap-20 items-center`}
            >
              {/* Image */}
              <div className="w-full lg:w-1/2">
                <div className="relative rounded-3xl overflow-hidden shadow-xl group">
                  <div className="w-full h-80 lg:h-96">
                    <img
                      src={service.image}
                      alt={service.alt}
                      title={service.schemaName}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
                    />
                  </div>
                  <div className="absolute top-6 left-6">
                    <span className="inline-flex items-center gap-2 px-4 py-2 bg-white/90 backdrop-blur-sm rounded-full text-xs font-semibold text-gray-800 shadow-sm">
                      <i className={`${service.icon} text-amber-600`}></i>
                      {service.tag}
                    </span>
                  </div>
                </div>
              </div>

              {/* Content */}
              <div className="w-full lg:w-1/2">
                <span className="text-xs font-medium text-amber-600 uppercase tracking-widest mb-3 block">
                  {service.subtitle}
                </span>
                <h3 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4 leading-tight" style={{ fontFamily: 'Playfair Display, serif' }}>
                  {service.title}
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed mb-8">
                  {service.description}
                </p>

                <ul className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-10">
                  {service.features.map((feat) => (
                    <li key={feat} className="flex items-center gap-3 text-sm text-gray-700">
                      <span className="w-5 h-5 flex items-center justify-center rounded-full bg-amber-100 text-amber-700 flex-shrink-0">
                        <i className="ri-check-line text-xs"></i>
                      </span>
                      {feat}
                    </li>
                  ))}
                </ul>

                <div className="flex flex-col sm:flex-row gap-3">
                  <Link
                    to="/offerte"
                    className="inline-flex items-center justify-center gap-2 bg-gray-900 text-white px-6 py-3 rounded-lg text-sm font-medium hover:bg-gray-700 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    Offerte Aanvragen
                    <i className="ri-arrow-right-line"></i>
                  </Link>
                  <Link
                    to={`/photos?category=${service.id}`}
                    className="inline-flex items-center justify-center gap-2 border border-gray-200 text-gray-700 px-6 py-3 rounded-lg text-sm font-medium hover:bg-gray-50 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    Bekijk Projecten
                    <i className="ri-image-line"></i>
                  </Link>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export { services };
export default ServiziList;
